const createSubmenu = () => {

    const submenuLinks = document.getElementsByClassName('submenu-link');
    let activeLink = null;


    for (const link of submenuLinks) {
        const plus = link.getElementsByClassName('submenu-link__plus');
        const minus = link.getElementsByClassName('submenu-link__minus');

        link.addEventListener('mouseenter', function () {
            if (window.innerWidth>= 680 ) {
                handleActiveLink(link);
            }
        });

        if(plus.length >= 1) {
            plus[0].onclick =  function () {

                if (window.innerWidth<= 680) {
                    if(minus.length >= 1) {
                        addOrRemoveClass(link, plus[0], minus[0]);

                        minus[0].onclick =  function () {
                            addOrRemoveClass(link, plus[0], minus[0]);
                        };

                    };

                }
            };

        }
    }


    function handleActiveLink(link) {

        if(activeLink === link) {
            return;
        }

        if(activeLink) {
            addOrRemoveClass(activeLink);
        }
        activeLink = link;
        addOrRemoveClass(activeLink);
    }

    function addOrRemoveClass(link, plus, minus) {
        const sibling = link.nextElementSibling;

        if(plus) {
            if(plus.classList.contains('hide')) {
                plus.classList.remove('hide');
            }else {
                plus.classList.add('hide');
            }
        }
        if(minus) {
            if(minus.classList.contains('show')) {
                minus.classList.remove('show');
            }else {
                minus.classList.add('show');
            }
        }

        if(sibling.classList.contains('submenu-link__content')){

            if(sibling.classList.contains('display')) {
                link.classList.remove('hover');
                sibling.classList.remove('display');
            }else {
                link.classList.add('hover');
                sibling.classList.add('display');
            }
        }else {
            if(link.classList.contains('hover')) {
                link.classList.remove('hover');
            }else {
                link.classList.add('hover');
            }
        }

    }


}

    document.addEventListener('readystatechange', () => {
            createSubmenu();

    });

